import React, { FC, useState } from 'react';
import { styled } from 'linaria/react';
import { accordionSizes, accordionGapsRem, accordionGapsPx } from '@shared/config/components/accordion';
import AccordionItem, { AccordionItemType } from './AccordionItem';
type SizeValue = keyof typeof accordionSizes;
type ResponsiveSize = SizeValue | {
  mobile: SizeValue;
  desktop: SizeValue;
};
interface AccordionProps {
  size?: ResponsiveSize;
  items: AccordionItemType[];
}
const Accordion: FC<AccordionProps> = ({
  size = 'l',
  items
}) => {
  const [activeIndexes, setActiveIndexes] = useState<number[]>([]);
  const toggleAccordionItemState = (index: number) => {
    setActiveIndexes(prev => prev.includes(index) ? prev.filter(i => i !== index) // закрыть
    : [...prev, index] // открыть
    );
  };
  const desktopSize = typeof size === 'object' ? size.desktop || 'l' : size || 'l';
  const mobileSize = typeof size === 'object' ? size.mobile || desktopSize : size || 'l';
  return <AccordionWrapper desktopSize={desktopSize} mobileSize={mobileSize}>
      {items.map((item, index) => {
      const isOpen = activeIndexes.includes(index);
      return <AccordionItem key={index} size={{
        desktop: desktopSize,
        mobile: mobileSize
      }} index={index} item={item} isOpen={isOpen} toggleAccordionItemState={toggleAccordionItemState} />;
    })}
    </AccordionWrapper>;
};
export default Accordion;
type AccordionWrapperProps = {
  desktopSize: SizeValue;
  mobileSize: SizeValue;
};
const _exp = /*#__PURE__*/() => ({
  desktopSize
}) => accordionGapsRem[desktopSize];
const _exp2 = /*#__PURE__*/() => ({
  mobileSize
}) => accordionGapsPx[mobileSize];
const AccordionWrapper = /*#__PURE__*/styled('div')({
  name: "AccordionWrapper",
  class: "atunqm1",
  propsAsIs: false,
  vars: {
    "atunqm1-0": [_exp()],
    "atunqm1-1": [_exp2()]
  }
});

require("./Accordion.linaria.module.css!=!../../../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./Accordion.tsx");